import {
  isReauthenticationRequired,
  isNetworkFailure
} from '../services/passkey'

/**
 * パスキーの登録が通らなかったときの見分けと、言い方。
 *
 * <h3>「やめた」と「失敗した」を分ける</h3>
 *
 * <p>端末の確認画面（顔・指紋・PIN）を閉じると、ブラウザは
 * <b>NotAllowedError</b> を投げる。これは時間切れでも同じ。つまり
 * <b>本人が途中でやめたとき</b>に来るもので、故障ではない。</p>
 *
 * <p>ここを赤いエラーで出すと、やめただけの人に「何か壊した」と
 * 思わせる。押し間違えて閉じた人ほど、もう一度押さなくなる。</p>
 *
 * <h3>1か所に置く理由</h3>
 *
 * <p>同じ文言が設定画面と、ログイン直後のダイアログの2か所に要る。
 * 写すと片方だけ直る。<b>増える口は、増えたときに全部へ届くこと。</b></p>
 */

/**
 * 本人が途中でやめたか（取り消し・時間切れ）。
 *
 * <p>これが true のときは<b>失敗として見せない。</b></p>
 */
export function isPasskeyGivenUp (error) {
  return Boolean(error) && error.name === 'NotAllowedError'
}

/**
 * この端末がすでに登録済みか。
 *
 * <p>ブラウザが excludeCredentials を見て断った状態。
 * <b>やることは何も残っていない</b>ので、失敗ではなく「済んでいる」
 * として見せる。</p>
 */
export function isPasskeyAlreadyOnThisDevice (error) {
  return Boolean(error) && error.name === 'InvalidStateError'
}

/**
 * 登録が通らなかった理由の言い方。
 *
 * <p>ブラウザ側で断られる場合（取り消した、端末が対応していない、
 * ドメインが合っていない）は、サーバの応答が無い。<b>通信の失敗と
 * 混ぜない。</b>混ぜると「接続を確認してください」と出るが、実際には
 * 接続の問題ではない。</p>
 */
export function describePasskeyRegisterFailure (error) {
  if (isReauthenticationRequired(error)) {
    return 'もう一度ログインの確認が必要です。'
      + ' 一度ログアウトして再ログインしてから、もう一度お試しください。'
  }
  if (isPasskeyGivenUp(error)) {
    return '登録が取り消されました。もう一度お試しください。'
  }
  if (error && error.name === 'SecurityError') {
    return 'この画面のURLではパスキーを登録できません。'
      + ' いつものログイン画面のURLからログインし直して、もう一度お試しください。'
      + ' それでも登録できない場合は、社内の管理者へお問い合わせください。'
  }
  if (isPasskeyAlreadyOnThisDevice(error)) {
    return 'この端末は、すでにパスキーとして登録されています。'
  }
  if (isNetworkFailure(error)) {
    return '通信できませんでした。接続を確認してからお試しください。'
  }
  return serverText(error) || 'パスキーを登録できませんでした。時間をおいて再度お試しください。'
}

/** サーバが返した文言。無ければ null。 */
function serverText (error) {
  const response = error && error.response
  const data = (response && response.data) || {}
  return typeof data.message === 'string' && data.message
    ? data.message
    : null
}
